export class ManageSecurityGroupsViewModel
{
    addedSecurityGroups: string[];
    removedSecurityGroups: string[];
}
